// SEC-348: Dutch for the date pickers.
// The package's own "vue2-datepicker/locale/nl" also makes Dutch the default
// for every picker that has no lang prop, which would switch those pickers to
// Dutch for Swedish and Norwegian users too. So Dutch is registered here as a
// local language only (third argument): pickers that ask for "nl" get Dutch,
// and the default stays exactly as it was. The texts are the package's own.
import DatePicker from "vue2-datepicker";
import nl from "date-format-parse/lib/locale/nl";

DatePicker.locale(
  "nl",
  {
    formatLocale: nl,
    yearFormat: "YYYY",
    monthFormat: "MMM",
    monthBeforeYear: true,
  },
  true
);
